import { render, staticRenderFns } from "./indicatorLoad.vue?vue&type=template&id=1be9e222&"
var script = {}
import style0 from "./indicatorLoad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports